import {ChangeDetectorRef, Component, OnInit} from '@angular/core';
import {CategoryService} from '@app/services/category.service';
import {CmsComponentData} from '@spartacus/storefront';
import {
  CmsFlexComponentData
} from '@app/checkout/order-confirmation/order-confirmation-list-item/order-confirmation-order-item.model';
import {ComponentService} from '@app/services/component.service';
import {FetchTextsComponent} from '@app/shared/fetch-texts/fetch-texts.component';
import {Category} from '@spartacus/core';

@Component({
  selector: 'dcp-browse-category',
  templateUrl: './browse-category.component.html',
  styleUrls: ['./browse-category.component.scss']
})
export class BrowseCategoryComponent extends FetchTextsComponent implements OnInit {
  categories: Array<Category>;

  constructor(public categoryService: CategoryService,
              protected cmsData: CmsComponentData<CmsFlexComponentData>,
              protected componentService: ComponentService,
              protected cdr: ChangeDetectorRef,
  ) {
    super(cmsData, componentService, cdr);
  }

  ngOnInit() {
    this.categories = this.categoryService.getCategories().sort((a, b) =>
      a.translationKey.localeCompare(b.translationKey));
    this.fetchComponentData();
  }

  showProductsForCategory(categoryId: string): void {
    this.categoryService.displayProductsOfCategory(categoryId);
  }
}
